module.exports = __webpack_public_path__ + "img/hover_icon_manejo_solicitudes_materiales_y_equipos.e57be281.svg";